import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import { getToolPartOutputRecord } from "./bedrock-shared";

export function getOrdersFindDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const orders = Array.isArray(outputRecord?.orders)
    ? outputRecord.orders
    : null;
  if (!orders) {
    return null;
  }

  if (orders.length === 0) {
    return "and found none";
  }

  return `and found ${orders.length === 1 ? "1 order" : `${orders.length} orders`}`;
}

export function getOrderEventsDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const events = Array.isArray(outputRecord?.events)
    ? outputRecord.events
    : null;
  if (!events) {
    return null;
  }

  return `with ${events.length === 1 ? "1 event" : `${events.length} events`}`;
}
